module.exports = __webpack_public_path__ + "static/media/album_cover_flower_boy.862dbf87.png";